import React, { useState, useEffect } from 'react';
import { Modal } from '../../../components/Modal';
import { vmsService } from '../../../services/vmsService';

interface ManageVendorTypesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ManageVendorTypesModal: React.FC<ManageVendorTypesModalProps> = ({ isOpen, onClose }) => {
  const [vendorTypes, setVendorTypes] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editingId, setEditingId] = useState<number | null>(null);
  const [formData, setFormData] = useState({ name: '', description: '' });

  useEffect(() => {
    if (isOpen) {
      fetchTypes();
    }
  }, [isOpen]);

  const fetchTypes = async () => {
    try {
      const data = await vmsService.getVendorTypes();
      setVendorTypes(data.results || data);
    } catch (err) {
      console.error('Failed to fetch vendor types', err);
    }
  };

  const handleEdit = (type: any) => {
    setEditingId(type.id);
    setFormData({ name: type.name, description: type.description || '' });
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setFormData({ name: '', description: '' });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      if (editingId) {
        await vmsService.updateVendorType(editingId, formData);
      } else {
        await vmsService.createVendorType(formData);
      }
      setFormData({ name: '', description: '' });
      setEditingId(null);
      fetchTypes();
    } catch (err) {
      alert('Failed to save vendor type');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Manage Vendor Types">
      <div className="modal-body" style={{ padding: '1.5rem' }}>
        <form onSubmit={handleSubmit} style={{ marginBottom: '2rem', display: 'flex', gap: '1rem', alignItems: 'flex-end' }}>
          <div className="form-field" style={{ flex: 1, marginBottom: 0 }}>
            <label>Name *</label>
            <input type="text" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} required />
          </div>
          <div className="form-field" style={{ flex: 2, marginBottom: 0 }}>
            <label>Description</label>
            <input type="text" value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} />
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            {editingId && (
              <button type="button" className="secondary-btn" onClick={handleCancelEdit}>Cancel</button>
            )}
            <button type="submit" className="primary-btn" disabled={isLoading}>
              {editingId ? 'Update' : 'Add'}
            </button>
          </div>
        </form>

        <div className="list-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {vendorTypes.map(type => (
                <tr key={type.id}>
                  <td><strong>{type.name}</strong></td>
                  <td>{type.description || '-'}</td>
                  <td>
                    <button className="secondary-btn sm-btn" onClick={() => handleEdit(type)}>Edit</button>
                  </td>
                </tr>
              ))}
              {vendorTypes.length === 0 && (
                <tr>
                  <td colSpan={3} style={{ textAlign: 'center' }}>No vendor types found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="primary-btn" onClick={onClose}>Done</button>
      </div>
    </Modal>
  );
};
